import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  noIndex?: boolean;
  schemaJson?: object | object[];
}

export const SEOHead = ({
  title,
  description,
  canonical,
  ogImage,
  noIndex,
  schemaJson,
}: SEOHeadProps) => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://miros-haushaltsaufloesung.de/#localbusiness",
    name: "Miros Haushaltsauflösung",
    image:
      "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/698f5d79c6490f2e4d428a9e.png",
    url: "https://miros-haushaltsaufloesung.de/",
    telephone: "+4915253181061",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Hauptstraße 43-44",
      addressLocality: "Berlin",
      postalCode: "13127",
      addressCountry: "DE",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 52.5833,
      longitude: 13.4,
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "08:00",
      closes: "20:00",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "5.0",
      reviewCount: "500",
    },
    sameAs: [
      "https://www.google.com/maps/place/Miros+Haushaltsaufl%C3%B6sung/@52.7890372,12.4843482,9z/data=!3m1!4b1!4m6!3m5!1s0x23bf4a60473c084d:0x8a12d3b416c3d36a!8m2!3d52.7890372!4d12.4843482!16s%2Fg%2F11w12b1_n0",
    ],
  };

  const finalSchema = schemaJson
    ? Array.isArray(schemaJson)
      ? schemaJson.some((s: any) => s["@type"] === "LocalBusiness")
        ? schemaJson
        : [localBusinessSchema, ...schemaJson]
      : [localBusinessSchema, schemaJson]
    : [localBusinessSchema];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {canonical && <meta property="og:url" content={canonical} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {canonical && <link rel="canonical" href={canonical} />}

      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {!noIndex && <meta name="robots" content="index, follow" />}

      {finalSchema && (
        <script type="application/ld+json">
          {JSON.stringify(finalSchema)}
        </script>
      )}
    </Helmet>
  );
};
